(() => {
  const root = document.querySelector('[data-accessory-product]');
  if (!root) return;

  const stageImage = root.querySelector('[data-gallery-stage-image]');
  root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!stageImage) return;
      stageImage.src = thumb.dataset.fullSrc;
      stageImage.alt = thumb.dataset.alt || '';
      root.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    });
  });

  const variantId = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-product-price]');
  const comparePrice = root.querySelector('[data-compare-price]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const addText = root.querySelector('[data-add-to-cart-text]');
  const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
  root.querySelectorAll('[data-variant-option]').forEach((option) => {
    option.addEventListener('change', () => {
      if (!option.checked) return;
      if (variantId) variantId.value = option.value;
      if (price) price.textContent = option.dataset.price || '';
      if (option.dataset.packTitle) {
        const packDescription = root.querySelector('[data-pack-description]');
        if (packDescription) packDescription.textContent = option.dataset.packDescription || '';
        if (stageImage && option.dataset.variantImage) {
          stageImage.removeAttribute('srcset');
          stageImage.src = option.dataset.variantImage;
          stageImage.alt = option.dataset.variantImageAlt || '';
        }
        root.querySelectorAll('[data-pack-thumb]').forEach((thumb) => {
          const active = thumb.dataset.packThumb === option.value;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-pressed', String(active));
        });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
      }
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.classList.toggle('is-hidden', !option.dataset.comparePrice);
      }
      const available = option.dataset.available === 'true';
      if (addButton) addButton.disabled = !available;
      if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold out';
      if (dynamicCheckout) {
        dynamicCheckout.toggleAttribute('inert', !available);
        dynamicCheckout.setAttribute('aria-disabled', String(!available));
        const buyNowButton = dynamicCheckout.querySelector('[data-mt-buy-now]');
        if (buyNowButton) buyNowButton.disabled = !available;
      }
    });
  });

  root.querySelectorAll('[data-pack-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const option = Array.from(root.querySelectorAll('[data-variant-option]'))
        .find((input) => input.value === thumb.dataset.packThumb);
      if (!option) return;
      option.checked = true;
      option.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  const quantity = root.querySelector('[data-quantity-input]');
  root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
    if (!quantity) return;
    quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
  });
  root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
    if (!quantity) return;
    quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
  });
})();
